import React from "react";
import { useAuthStore } from "../../store/authStore";
interface ActionButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  label,
  onClick,
  disabled = false,
}) => {
  const darkMode = useAuthStore((state) => state.darkMode);

  return (
    <button
      className={`w-full py-3 px-4 rounded-lg transition-colors    ${
        disabled
          ? "bg-pluto-disabled cursor-default opacity-50"
          : "bg-black dark:bg-white cursor-pointer text-white dark:text-black  hover:opacity-90 "
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

export default ActionButton;
